/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { withLatestFrom, pluck, switchMap } from 'rxjs/operators';
import { filterAvailabilityBySearchCampsites } from '../../utils/availabilityReducerUtil';
import {
    GET_AVAILABLE_CAMPSITES,
    FILTER_AVAILABILITIES_BY_SEARCH_COMPLETE,
} from '../../constants';

/**
 *
 * @param {Observable} action$ - a stream of actions
 * @param {Observable} state$ - a stream of redux store states
 */
export const filterAvailabilityBySearchEpic = (action$, state$) =>
    action$.pipe(
        ofType(
            GET_AVAILABLE_CAMPSITES // when search filter changes
        ),
        withLatestFrom(state$.pipe(pluck('availableCampsites'), pluck('results'))),
        switchMap((stream) => {
            const state = stream[1];
            const { campsites } = state;

            const filteredAvailabilitiesBySearch =
                filterAvailabilityBySearchCampsites(campsites);

            return of({
                type: FILTER_AVAILABILITIES_BY_SEARCH_COMPLETE,
                payload: filteredAvailabilitiesBySearch,
            });
        })
    );
